"use client";

import { TriangleAlert, XIcon } from "lucide-react";

export const ErrorMessage = ({ error }: { error: string | Error | null }) => {
  if (!error) return null;

  return (
    <div className="flex align-center mt-2 bg-red-100 p-2 rounded shadow-md pl-4">
      <div className="flex items-center justify-center w-8 h-8 bg-red-200 rounded-full mr-2">
        <TriangleAlert className="h-4 w-4 text-red-600" />
      </div>
      <div className="flex text-sm text-red-700 items-center">
        {error instanceof Error ? (
          <span>{error.message}</span>
        ) : (
          <span>{error}</span>
        )}  
      </div>
    </div>
  );
}